import { useEffect } from 'react';
import { sort } from 'utils/sort';
import { getLocalDateFormat } from 'utils/date';
import { useSetState } from 'react-use';

const useItemSearch = ({ key = 'name' }) => {
  const [state, setState] = useSetState({
    search: '',
    sort: null,
    items: [],
    filteredItems: []
  });

  useEffect(() => {
    const filteredItems = !state.search
      ? state.items
      : state.items.filter(i => {
          if (findStringInItems(i, state.search)) return true;
        });

    if (state.sort) {
      setState({
        filteredItems: sort(filteredItems, {
          keys: [state.sort]
        })
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.items, state.search, state.sort]);

  const findStringInItems = (item, str) => {
    const trimmedString = str.toLowerCase().trim();
    const itemName = item[key].toLowerCase().trim();
    if (itemName.indexOf(trimmedString) !== -1) return true;
    // TODO: should be more dynamic
    if (item?.testSets) {
      const tesSetName = item.testSets?.[0]?.name
        ? item.testSets[0].name.toLowerCase().trim()
        : '';
      if (tesSetName.indexOf(trimmedString) !== -1) return true;
    }
    if (item?.startdate) {
      const dateName = getLocalDateFormat(item.startdate);
      if (dateName.indexOf(trimmedString) !== -1) return true;
    }
  };

  return [state, setState];
};

export default useItemSearch;
